import { render, staticRenderFns } from "./bandCard.vue?vue&type=template&id=1d1dab3e&scoped=true"
import script from "./bandCard.vue?vue&type=script&lang=js"
export * from "./bandCard.vue?vue&type=script&lang=js"
import style0 from "./bandCard.vue?vue&type=style&index=0&id=1d1dab3e&prod&lang=scss&scoped=true"
import style1 from "./bandCard.vue?vue&type=style&index=1&id=1d1dab3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1dab3e",
  null
  
)

export default component.exports